function findErrors(records) {
  // check for errors
  let ERRORS = 0;

  records.forEach((record) => {
    record.forEach((field) => {
      if (field.error !== "") {
        ERRORS += 1;
      }
    });
  });

  return ERRORS;
}

export default findErrors;
